//#region ../src/constants.js
var e = {
	100: "d-icon--size-100",
	200: "d-icon--size-200",
	300: "d-icon--size-300",
	400: "d-icon--size-400",
	500: "d-icon--size-500",
	600: "d-icon--size-600",
	700: "d-icon--size-700",
	800: "d-icon--size-800"
};
//#endregion
export { e as t };

//# sourceMappingURL=constants-B7fXbm2f.js.map